import { render, staticRenderFns } from "./TeaList.vue?vue&type=template&id=26bf4524&scoped=true"
import script from "./TeaList.vue?vue&type=script&lang=js"
export * from "./TeaList.vue?vue&type=script&lang=js"
import style0 from "./TeaList.vue?vue&type=style&index=0&id=26bf4524&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Vue/course_selecttion_v3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bf4524",
  null
  
)

export default component.exports